import { guardExist as e } from "@smh/utils/guards";
class l {
  get _oneSignalSDK() {
    return window.OneSignal = window.OneSignal || [], window.OneSignal;
  }
  init(i) {
    const n = {
      appId: i.appId
    }, { swParams: o, promptSettings: s, welcomeNotification: t } = i;
    if (e(o) && (n.serviceWorkerParam = o.param, n.serviceWorkerPath = o.path), e(s) && (n.promptOptions = s), e(t) && (n.welcomeNotification = t), this._oneSignalSDK instanceof Array)
      throw new Error("OneSignal is not defined");
    return new Promise((S, a) => {
      this._oneSignalSDK.push(() => {
        e(o) && (this._oneSignalSDK.SERVICE_WORKER_PARAM = o.param, this._oneSignalSDK.SERVICE_WORKER_PATH = o.path), this._oneSignalSDK.init(n).then(S).catch(a);
      });
    });
  }
  sendTag(i, n = "1") {
    return new Promise((o, s) => {
      this._oneSignalSDK.push(() => {
        this._oneSignalSDK.sendTag(i, n).then(o).catch(s);
      });
    });
  }
  closeSlidedownPrompt() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.slidedown.close();
    });
  }
  showSlidedownPrompt(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.showSlidedownPrompt(i);
    });
  }
  showNativePrompt() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.registerForPushNotifications();
    });
  }
  checkNotificationsSupportState() {
    let i = !1;
    return this._oneSignalSDK.push(() => {
      i = this._oneSignalSDK.isPushNotificationsSupported();
    }), i;
  }
  checkNotificationsState() {
    return new Promise((i, n) => {
      this._oneSignalSDK.push(async () => {
        await this._oneSignalSDK.isPushNotificationsEnabled().then((o) => {
          i(o);
        }).catch(n);
      });
    });
  }
  checkBrowserPermission() {
    return new Promise((i, n) => {
      this._oneSignalSDK.push(async () => {
        await this._oneSignalSDK.getNotificationPermission().then((o) => {
          i(o);
        }).catch(n);
      });
    });
  }
  subscribePermissionPromptDisplay(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on("permissionPromptDisplay", i);
    });
  }
  subscribePopoverShown(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on("popoverShown", i);
    });
  }
  subscribePopoverClosed(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on("popoverClosed", i);
    });
  }
  subscribePopoverAllow(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on("popoverAllowClick", i);
    });
  }
  subscribePopoverDisallow(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on("popoverCancelClick", i);
    });
  }
  subscribeToNotificationsStateChange(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on("subscriptionChange", i);
    });
  }
  subscribeToBrowserPermissionChange(i) {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.on(
        "notificationPermissionChange",
        (n) => {
          const o = (n == null ? void 0 : n.to) || "default";
          i(o);
        }
      );
    });
  }
  unsubscribePermissionPromptDisplay() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("permissionPromptDisplay");
    });
  }
  unsubscribePopoverShown() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("popoverShown");
    });
  }
  unsubscribePopoverClosed() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("popoverClosed");
    });
  }
  unsubscribePopoverAllow() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("popoverAllowClick");
    });
  }
  unsubscribePopoverDisallow() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("popoverCancelClick");
    });
  }
  unsubscribeToNotificationsStateChange() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("subscriptionChange");
    });
  }
  unsubscribeToBrowserPermissionChange() {
    this._oneSignalSDK.push(() => {
      this._oneSignalSDK.off("notificationPermissionChange");
    });
  }
  getPlayerId() {
    return new Promise((i, n) => {
      this._oneSignalSDK.push(() => {
        this._oneSignalSDK.getUserId().then((o) => i(o)).catch(n);
      });
    });
  }
  setSubscriptionState(i) {
    this._oneSignalSDK.setSubscription(i);
  }
}
export {
  l as OneSignal
};
